import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid2'
import * as React from 'react'
import FilmAdd from './../../assets/icons/FilmAdd.svg'

import LockIcon from '@mui/icons-material/Lock'
import { Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useProfileStore } from '../../store/storeProfile'
import { useWrapperStore } from '../../store/storeWrapper'

export const RecordUpload: React.FC = () => {
    const { projectListActive, isTempUser } = useWrapperStore((state) => state)
    const { isFullAccess, userTariff } = useProfileStore()

    const navigate = useNavigate()

    return (
        <Grid>
            <Button
                disabled={
                    !projectListActive?.length ||
                    isTempUser ||
                    !isFullAccess ||
                    !userTariff?.tariff?.restrictions?.is_recording_available
                }
                fullWidth
                sx={{ my: 2 }}
                variant="contained"
                color="secondary"
                startIcon={isTempUser ? <LockIcon /> : <FilmAdd />}
                onClick={() => {
                    navigate('/records/upload')
                }}>
                Загрузить запись
            </Button>
            {!userTariff?.tariff?.restrictions?.is_recording_available && (
                <Typography variant="h6" sx={{ color: '#181B25' }}>
                    Недоступно на Текущем уровне
                </Typography>
            )}
        </Grid>
    )
}
